import { orderDetailsButtonSetStyles as styles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.printButton = {
    ...styles.printButton,
    css: css`
        span {
            color: ${getColor("secondary.main")};
        }
    `,
}